























































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Institution from "@/models/porposal/institution.Model";
@Component
export default class InstitutionAdd extends GenericAdd<Institution> {
  constructor() {
    super();
    this.controller = "Institutions";
    this.model = new Institution();
 
  }

}
